import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
const viewMode = wixWindow.viewMode;

$w.onReady(async function () {
	init();
	const initialData = await $w('#albumsGallery').onReady();
	refreshAlbumData(initialData);
	if (viewMode === "Preview") {
		$w('#albumsGallery').onRefreshHappened((data) => {
			refreshAlbumData(data);
		});
		$w('#albumsGallery').reportPageLoaded('sets');
	}
})

function init() {
	$w('#galleryName').hide && $w('#galleryName').hide()

	$w('#line1').hide && $w('#line1').hide()

	$w('#backButtonBox').show && $w('#backButtonBox').show()
	$w('#accountNavBar1').show && $w('#accountNavBar1').show()

	$w('#albumNameBox').show && $w('#albumNameBox').show()	
	$w('#albumName').link = '/';

	$w('#shareAndDownloadBox').show && $w('#shareAndDownloadBox').show();
}

function refreshAlbumData({albumData, sets}) {
	try {
		if (!albumData || !sets) {
			return;
		}
		if (albumData.allowSelections) {
			$w('#accountNavBar1').show();
		} else {
			$w('#accountNavBar1').hide();
		}
		if (albumData.hideLinkToCover) {
			$w('#backButtonBox').hide();
		}
		$w('#albumName').label = albumData.albumName;
		$w('#backButton').link = '/';

		$w('#downloadButton').link = albumData.zipUrl;
		const {allowAlbumDownload, styleParams: {allowSocial}} = albumData;
		
		$w('#downloadMobile').link = albumData.zipUrl;
		if(allowSocial){
			$w('#shareBox').show() 
			$w('#shareBoxMobile').show()
		}else {
			$w('#shareBox').hide();
			$w('#shareBoxMobile').hide()
		}

		if(allowAlbumDownload){
			$w('#downloadBox').show()
			$w('#downloadBoxMobile').show()
		} else {
			$w('#downloadBox').hide();
			$w('#downloadBoxMobile').hide()
		}

	} catch (e) {
		console.error("Error_On_Page", e);
	}
}


$w.onReady(function () {
	$w('#facebook').link = `https://www.facebook.com/sharer/sharer.php?u=${wixLocation.url}`;
	$w('#facebook').target = "_blank"

	$w('#twitter').link = `http://twitter.com/share?url=${wixLocation.url}`;
	$w('#twitter').target = "_blank";

	$w('#pinterest').link = `http://pinterest.com/pin/create/button/?url=${wixLocation.url}`;
	$w('#pinterest').target = "_blank";

	$w('#tumblr').link = `http://tumblr.com/share/link?url=${wixLocation.url}`;
	$w('#tumblr').target = "_blank";

    $w('#mail').onClick(()=>{
	   $w('#albumsGallery').mailToFunc(wixLocation.url)
	})
});